import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_WEEKLY_CRYPTO_RATES_HISTORY = 'FETCH_WEEKLY_CRYPTO_RATES_HISTORY'
export const RECEIVE_WEEKLY_CRYPTO_RATES_HISTORY = 'RECEIVE_WEEKLY_CRYPTO_RATES_HISTORY'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_WEEKLY_CRYPTO_RATES_HISTORY,
	receive: RECEIVE_WEEKLY_CRYPTO_RATES_HISTORY
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchWeeklyCryptoRatesHistory = (filters, force) => fetch('weeklyCryptoRatesHistory', 'cryptorates', actionTypes, {}, filters, force)
